export default __webpack_public_path__ + "static/media/glasses13.4c4d0c02.jpeg";